"use client";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { useLocale, useTranslations } from "next-intl";
import React, { useEffect, useState } from "react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { cn } from "@/lib/utils";
import VariableImage from "./ui/VariableImage";

gsap.registerPlugin(useGSAP);

const CustomSwiper = ({ slides }: { slides: any[] }) => {
  const [mounted, setMounted] = useState(false);
  const t = useTranslations("global");
  const locale = useLocale();
  const direction = locale === "en" ? "ltr" : "rtl";
  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div
      className={cn(
        "relative min-h-[500px]",
        slides.length > 4 && "xl:carousel-drag",
      )}
    >
      {slides.length > 4 && (
        <div className="mouse-drag-icon pointer-events-none absolute top-0 left-0 z-10 hidden size-32 rounded-full border-2 border-white text-white capitalize opacity-0 backdrop-blur-lg lg:flex-center">
          {t("drag")}
        </div>
      )}
      <Carousel
        className={cn(
          "overflow-visible! w-full pb-10!",
          slides.length > 4 && "cursor-grab",
        )}
        opts={{ align: "start", loop: false, dragFree: true, direction }}
      >
        <CarouselContent className="">
          {slides.map((slide: any, i: number) =>
            "Title" in slide ? (
              <CarouselItem
                key={i}
                className="md:basis-1/2 lg:basis-1/3 xl:basis-1/4"
              >
                <div className="relative aspect-4/3 w-full">
                  <VariableImage
                    src={slide.Media.data.attributes.url}
                    alt={slide.Media.data.attributes.alternativeText}
                    caption={slide.Media.data.attributes.caption}
                    className="object-cover object-center"
                    fill={true}
                    sizes="350px 230px"
                  />
                </div>
                <h3 className="title-20 my-5 font-semibold capitalize! text-themeWhite">
                  {slide.Title}
                </h3>
                <p className="whitespace-pre-line">{slide.Description}</p>
              </CarouselItem>
            ) : (
              <CarouselItem
                key={i}
                className="basis-full pl-5 md:basis-auto md:max-w-[350px] md:flex-[0_0_auto] md:pl-[30px]"
              >
                <div className="relative aspect-4/3 w-full">
                  <VariableImage
                    src={slide.img}
                    alt={slide.Media.data.attributes.alternativeText}
                    caption={slide.Media.data.attributes.caption}
                    className="object-cover object-center"
                    fill={true}
                    sizes="350px 230px"
                  />
                </div>
                <h3 className="title-20 my-5 font-semibold capitalize! text-themeWhite">
                  {slide.title}
                </h3>
                <p>{slide.text}</p>
              </CarouselItem>
            ),
          )}
        </CarouselContent>
      </Carousel>
    </div>
  );
};

export default CustomSwiper;
